import script from "./DeductionForecastV2View.vue?vue&type=script&setup=true&lang=js"
export * from "./DeductionForecastV2View.vue?vue&type=script&setup=true&lang=js"

import "./DeductionForecastV2View.vue?vue&type=style&index=0&id=77d46e0f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77d46e0f"]])

export default __exports__